import {
  star,
  unstar,
  getStars
} from '../service/starred'
import {
  pageCount
}
from '../../../src/config'
export default {
    namespaced: true,
    state(){
        return {
            fileList: [],
            initing: true,
            currentPage: 1,
            filter: 'all',
            maxPage: false,
            loading: false
        }
    },
    mutations:{
        INIT(state,{noinit}) {
          !noinit ? state.fileList = [] : ''
          state.initing = !noinit
          state.currentPage = 1
          state.maxPage = false
          state.loading = false
        },
        SAVE_FILES(state, {list,noinit}) {
          state.currentPage === 1 ? state.initing = false : null
          state.currentPage += 1
          state.maxPage = list.length < pageCount
          state.fileList = noinit ? list : state.fileList.concat(list)
        },
        SAVE_STAR(state,{fileid,sid}){
            state.fileList = sid ? state.fileList.filter(item => item.sid !== sid) : state.fileList.filter(item => item.fileid !== fileid)
        },
        SAVE_NAME(state,{fileid,fname}){
            state.fileList = state.fileList.map(item => {
                item.fileid == fileid ? item.fname = fname : ''
                return item
            })
        },
        LOADING(state, flag) {
            state.loading = flag
        }

    },
    actions:{
        flush({commit,dispatch},{noinit}){
            commit('INIT',{noinit})
            dispatch('loadmore',{noinit})
        },
        loadmore({commit,state},paload){
            if (state.maxPage || state.loading) {
              return
            }
            commit('LOADING', true)
            let offset = (state.currentPage - 1) * pageCount
            getStars({
                count: pageCount,
                offset
            },({status,data}) => {
                if (status === 200) {
                    commit('SAVE_FILES',{
                        list: data.files,
                        noinit: paload && paload.noinit
                    })
                }else{
                    commit('SAVE_FILES', {
                        list: [],
                        noinit: paload && paload.noinit
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                commit('LOADING', false)
            })
        },
        unstar({commit},{fileid,sid}){
            let paload = sid ? {sid} : {fileid}
            unstar(paload,({status,data}) => {
                if (status === 200) {
                     _dw.onEvent('drive_fileaction_unstar', {
                       type: 'success'
                     })
                  commit('SAVE_STAR', {...data,fileid,sid})
                } else {
                     _dw.onEvent('drive_fileaction_unstar', {
                       type: 'success',
                       result: data.result
                     })
                  commit('TOAST', {
                    type: 'error',
                    msg: data.result
                  }, {
                    root: true
                  })
                }
            })
        },
        rename({commit,dispatch},paload){
            dispatch('flush',{noinit:true})
            // commit('SAVE_NAME',paload)
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/starred.js